import { useState } from "react";
import BasicLayout from "../layauots/BasicLayout";
import { Alert, AlertTitle, Card } from "@mui/material";
import MDBox from "../controls/MDBox";
import MDTypography from "../controls/MDTypography";
import MDButton from "../controls/MDButton";
import { Link, useNavigate } from "react-router-dom";
import bgImage from "../../assets/images/bg-sign-up-cover.jpeg";
import { KeyFill } from "react-bootstrap-icons";
import MDInput from "../controls/MDInput";
import { postData } from "../Utils/Http/api";

const RecuperarPass = () => {
  const navigate = useNavigate();
  const [grabando, setGrabando] = useState(false);
  const [mensaje, setMensaje] = useState("");

  const [formData, setFormData] = useState({
    // Inicializa los campos del formulario
    email: "",
  });

  const handleInputChange = (event) => {
    // Maneja los cambios en los campos del formulario
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleForgotPassCancel = () => {
    localStorage.setItem('isRegister', 'false');
    localStorage.setItem('isLoggedIn', 'false');
    localStorage.setItem('isActivarCuenta', 'false');
    localStorage.setItem('isForgotPassword', 'false');
  };

  const handleSubmit = async (data) => {
    setGrabando(true);
    setMensaje("");
    try {
      const response = await postData(`/RecoveryPass/${formData.email}`);
      if (response.isSuccess) {
        setMensaje("✅ Se ha enviado un correo con la clave temporal para que puedas recuperar tu contraseña.");
        setTimeout(() => {
          console.log("Segunda línea");
        }, 2000);
        navigate("/RecoveryPassInfo");

      } else {
        setGrabando(false);
        setMensaje(response.error);
      }
    } catch (error) {
      setGrabando(false);
      setMensaje(error.message);
    }
  };
  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          p={3}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Recupero de Contraseña
          </MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>
            Ingresa el correo electrónico con el que te registraste
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form">

            <MDBox mb={2}>
              <MDInput
                type="email"
                name="email"
                label="Email"
                required
                variant="standard"
                value={formData.email}
                onChange={handleInputChange}

                fullWidth
              />
            </MDBox>
          </MDBox>
        </MDBox>
        <MDBox height="150px" textAlign="center">
          <MDButton disabled={grabando} variant="gradient" color="success" onClick={() => {
            handleSubmit();
          }} endIcon={<KeyFill />}>
            Recuperar Contraseña
          </MDButton>
        </MDBox>
        <MDBox mt={3} mb={1} textAlign="center">
          <MDTypography variant="button" color="text">
            Recordaste la clave?{" "}
            <MDTypography
              component={Link}
              to="/Login"
              variant="button"
              color="info"
              fontWeight="medium"
              textGradient
              onClick={() => {
                handleForgotPassCancel();
              }}
            >
              Ir al Inicio
            </MDTypography>
          </MDTypography>
        </MDBox>
        {mensaje !== '' && (
          <Alert severity={"info"}>
            <AlertTitle>{"Info"}</AlertTitle>
            {mensaje}
          </Alert>
        )}
      </Card>
    </BasicLayout>
  );
};

export default RecuperarPass;
